import React, { useState, useLayoutEffect } from 'react';
import { useTheme } from '@emotion/react';
import _throttle from 'lodash/throttle';

import {
  BodyContainer,
  LoadingContainer,
  ContentHeader,
  LoadingContent,
  LoadingSidebar,
  LoadingCell,
  ContentText,
  SidebarProfilePic,
  SidebarInfo
} from './scheduling-ui-loading-styles';

/**
 * This component is copied over from the Shimmer component in
 * direct-book-widget-v2. This allows us to entirely drop the direct-book-widget-v2
 * dependency when we push the MFE as the darkship default
 * @returns
 */

export function SchedulingUiLoading() {
  const theme = useTheme();
  const [aboveMd, setAboveMd] = useState(false);

  useLayoutEffect(() => {
    // Ensure the hook runs only in client-side code
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setAboveMd(window.innerWidth > parseInt(theme.db_screen_medium, 10));
      };

      // set initial value
      handleResize();

      const throttledHandler = _throttle(handleResize, 350);

      window.addEventListener('resize', throttledHandler);

      return () => {
        window.removeEventListener('resize', throttledHandler);
      };
    }
  }, []);

  return (
    <BodyContainer className="direct-book-container">
      <LoadingContainer data-testid="Loading">
        <LoadingContent>
          <ContentHeader>
            <LoadingCell />
          </ContentHeader>

          <ContentText>
            <div>
              <LoadingCell />
            </div>
            <div>
              <LoadingCell />
            </div>
          </ContentText>
        </LoadingContent>
        {aboveMd && (
          <LoadingSidebar>
            <SidebarProfilePic>
              <LoadingCell />
            </SidebarProfilePic>
            <SidebarInfo>
              <div>
                <LoadingCell />
              </div>
              <div>
                <LoadingCell />
              </div>
            </SidebarInfo>
          </LoadingSidebar>
        )}
      </LoadingContainer>
    </BodyContainer>
  );
}
